export default __webpack_public_path__ + "static/media/icon512x512.29c9ec2f.png";